import Swiper from 'swiper';
import { Autoplay } from 'swiper/modules';

import 'swiper/css';

let gameplaySwiper = null;
let keySwiper = null;

const MOBILE_BREAKPOINT = 1440;

function initGameplaySwiper() {
  const swiperElement = document.querySelector('.gameplay-swiper');

  if (!swiperElement || gameplaySwiper) return;

  gameplaySwiper = new Swiper(swiperElement, {
    modules: [Autoplay],

    slidesPerView: 1.3,
    spaceBetween: 16,

    loop: true,
    speed: 800,

    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
      pauseOnMouseEnter: true,
    },

    observer: true,
    observeParents: true,
  });
}

function initKeySwiper() {
  const swiperElement = document.querySelector('.key-swiper');

  if (!swiperElement || keySwiper) return;

  keySwiper = new Swiper(swiperElement, {
    modules: [Autoplay],

    slidesPerView: 1,
    spaceBetween: 16,

    loop: true,
    speed: 800,

    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
      pauseOnMouseEnter: true,
    },

    observer: true,
    observeParents: true,
  });
}

function destroyGameplaySwiper() {
  if (!gameplaySwiper) return;

  gameplaySwiper.destroy(true, true);
  gameplaySwiper = null;
}

function destroyKeySwiper() {
  if (!keySwiper) return;

  keySwiper.destroy(true, true);
  keySwiper = null;
}

function handleSwipers() {
  if (window.innerWidth < MOBILE_BREAKPOINT) {
    initGameplaySwiper();
    initKeySwiper();
  } else {
    destroyGameplaySwiper();
    destroyKeySwiper();
  }
}

handleSwipers();

window.addEventListener('resize', handleSwipers);